import { COLOR_PALETTE } from 'constants/ui';

export const rateTableRowStyles = {
  height: 74,
};

export const getFirstRateTableCellStyles = ({
  hasOptionsForSelection,
  hasTempSelectedOption,
  hasNewLoanOptionId,
}) => {
  return {
    fontWeight: 500,
    borderRight: '1px solid',
    borderColor: ({ palette }) => palette.border.default,

    color: ({ palette }) => {
      if (hasTempSelectedOption || hasNewLoanOptionId) {
        return COLOR_PALETTE.BRAND[6];
      }

      if (hasOptionsForSelection) {
        return palette.text.primary;
      }

      return palette.text.secondary;
    },

    backgroundColor: ({ palette }) => {
      if (hasTempSelectedOption || hasNewLoanOptionId) {
        return COLOR_PALETTE.BRAND[1];
      }

      return palette.background.secondary;
    },
  };
};
